import { Address } from 'types';

/* eslint-disable @typescript-eslint/camelcase */
export default class Staff {
  id = 0;

  first_name = '';

  last_name = '';

  email = '';

  accepted_customer_terms_at?: string;

  accepted_upper_hand_terms_at?: string;

  active_membership_color = '';

  active_membership_id = 0;

  active_membership_name = '';

  address?: Address;

  age = 0;

  availability_schedule_id = 0;

  date_of_birth = '';

  gender = '';

  get_email_notifications = false;

  invite_sent_at?: string;

  hourly_rate = 0;

  last_login_at?: string;

  login_enabled = false;

  managed_by_id = 0;

  managing_customer_user_id = 0;

  managing_customer_user_name = '';

  is_new_user = false;

  phone = '';

  // TODO. Need to add UpperHandImage type
  profile_image: { url: string } = { url: '' };

  has_purchases = false;

  time_zone = '';

  time_zone_name = '';

  time_zone_offset = '';

  type = '';

  user_id = 0;

  uuid = '';

  access_revoked_at?: string;

  preferences: object = {};

  created_at = '';

  updated_at = '';
}
